const routes = {
  api: {
    errors: '/api/v2/errors/error',
    admins: {
      index: '/api/v2/admins',
      create: '/api/v2/admins',
      destroy: (id) => `/api/v2/admins/${id}`,
      update: (id) => `/api/v2/admins/${id}`,
    },
    coach_pools: {
      index: '/api/v2/coach_pools',
      list: '/admin/coach_pools',
      create: '/api/v2/coach_pools',
      show: (id) => `/admin/coach_pools/${id}`,
      edit: (id) => `/admin/coach_pools/${id}/edit`,
      update: (id) => `/api/v2/coach_pools/${id}`,
      destroy: (id) => `/api/v2/coach_pools/${id}`,
      duplicate: (id) => `/api/v2/coach_pools/${id}/duplicate`,
      teams: (id) => `/api/v2/coach_pools/${id}/teams`,
    },
    session_rooms: {
      for_list: '/api/v1/session_rooms/for_list',
      archive: (id) => `/api/v1/session_rooms/${id}/archive`,
      sort: (id) => `/api/v1/session_rooms/${id}/sort`,
      show: (id) => `/api/v1/session_rooms/${id}`,
      messages: {
        index: (id) => `/api/v2/chats/${id}/messages`,
        create: (id) => `/api/v2/chats/${id}/messages`,
        update: (chatId, messageId) => `/api/v2/chats/${chatId}/messages/${messageId}`,
      },
    },
    students: {
      index: '/api/v1/students/',
      list: '/api/v1/students/list',
      match_coach: (id) => `/api/v1/students/${id}/match_coach`,
      enrollment: (id) => `/api/v1/students/${id}/enrollment`,
      cycles_status: (id) => `/api/v1/students/${id}/cycles_status`,
      show: (id) => `/api/v2/members/show/${id}`,
      edit: (id) => `/members/${id}/edit`,
      destroy: (id) => `/api/v2/members/${id}`,
      multi_destroy: '/api/v2/members/multi_destroy',
      update: (id) => `/api/v2/members/${id}`,
    },
    members: {
      index: '/api/v2/members/',
      show: (id) => `/api/v2/members/${id}`,
      programs: '/api/v2/programs',
      newProgram: '/api/v2/members/programs/new',
      newAiProgram: '/api/v2/members/programs/new_ai',
      createProgram: '/api/v2/members/programs',
      chooseNewCoach: (id) => `/api/v2/members/programs/${id}/choose_new_coach`,
      saveNewCoach: (id) => `/api/v2/members/programs/${id}/save_new_coach`,
      updateProgram: (id) => `/api/v2/members/programs/${id}`,
      recommendedCoaches: (id) => `/api/v2/members/programs/${id}/recommended-coaches`,
      possibilityScheduleSession: '/api/v2/members/schedule/possibility-schedule',
      profile: {
        update: (id) => `/api/v2/members/${id}`,
        updateCareerHistory: (id) => `/api/v2/members/${id}/update_career_history`,
        updateAiProgramGoals: (id) => `/api/v2/members/${id}/update_ai_program_goals`,
      },
      terminated: {
        lastTerminatedInvoice: '/api/v2/members/cycle_invoices/last_terminated_invoice',
        preparePayment: '/api/v2/members/cycle_invoices/prepare_payment',
      },
      onboarding: {
        index: '/api/v2/members/onboarding',
        completeStep: '/api/v2/members/onboarding/complete_step',
        complete: '/api/v2/members/onboarding/complete',
      },
      settings: {
        updateEmail: '/api/v2/users/update-email',
        updatePassword: '/api/v2/users/update-password',
        requestDelete: '/api/v2/users/request-delete',
      },
      activities: {
        index: '/api/v2/members/activities',
      },
      ratings: {
        index: '/api/v2/members/ratings',
      },
      schedule: {
        sessionsToSchedule: '/api/v2/members/schedule/sessions-to-schedule',
        nextSessions: '/api/v2/members/schedule/next-sessions',
        pastSessions: '/api/v2/members/schedule/past-sessions',
      },
      steps: {
        show: (stepId) => `/api/v2/members/steps/${stepId}`,
        session: (stepId) => `/api/v2/members/steps/${stepId}/session`,
        complete: (stepId) => `/api/v2/members/steps/${stepId}/complete`,
      },
      wallet: {
        show: '/api/v2/members/wallet',
        preparePayment: '/api/v2/members/wallet/prepare_payment',
        invoices: '/api/v2/members/wallet/invoices',
      },
      growth_reports: {
        index: '/api/v2/members/growth_reports',
        latest: '/api/v2/members/growth_reports/latest',
      },
      assessments: {
        index: '/api/v2/members/assessments',
        create: '/api/v2/members/assessments',
        destroy: (id) => `/api/v2/members/assessments/${id}`,
      },
      vector_storages: {
        create: '/api/v2/members/vector_storages',
      },
    },
    coaching_plans: {
      list: '/api/v1/coaching_plans/not_closed',
      saved_for_later: '/api/v1/coaching_plans/saved_for_later',
    },
    steps: {
      show: (stepId) => `/api/v2/steps/${stepId}`,
      chooseTopics: (stepId) => `/api/v2/steps/${stepId}/choose_topics`,
      updateTopic: (stepId) => `/api/v2/steps/${stepId}/update_topic`,
      skipSession: (stepId) => `/api/v2/steps/${stepId}/skip_session`,
      confirm: (stepId) => `/api/v2/steps/${stepId}/confirm`,
      session: {
        schedule: (stepId, startDate) => `/api/v2/steps/${stepId}/session/schedule?date=${startDate}`,
        prepareSession: (stepId) => `/api/v2/steps/${stepId}/session/prepare_session`,
        create: (stepId) => `/api/v2/steps/${stepId}/session`,
        update: (stepId) => `/api/v2/steps/${stepId}/session`,
        feedback: (stepId) => `/api/v2/steps/${stepId}/session/feedback`,
        show: (stepId) => `/api/v2/steps/${stepId}/session`,
        cancelType: (stepId) => `/api/v2/steps/${stepId}/session/cancel_type`,
        cancel: (stepId) => `/api/v2/steps/${stepId}/session`,
        generateIcs: (stepId) => `/api/v2/steps/${stepId}/session/generate_ics`,
      },
      step_resources: {
        show: (stepId, resourceId) => `/api/v2/step_resources/${resourceId}?step_id=${stepId}`,
      },
    },
    change_coach_requests: {
      create: '/api/v1/change_coach_requests',
      update: (id) => `/api/v1/change_coach_requests/${id}`,
      list: '/api/v1/change_coach_requests',
      show: (id) => `/api/v1/change_coach_requests/${id}`,
      destroy: (id) => `/api/v1/change_coach_requests/${id}`,
      accept: (id) => `/api/v1/change_coach_requests/${id}/accept`,
      decline: (id) => `/api/v1/change_coach_requests/${id}/decline`,
    },
    claims: {
      index: '/api/v2/claims',
      create: '/api/v2/claims',
      destroy: (id) => `/api/v2/claims/${id}`,
      update: (id) => `/api/v2/claims/${id}`,
    },
    coaches: {
      index: '/api/v2/coaches',
      list: '/api/v1/coaches/list',
      pause: '/api/v1/coaches/pause',
      sessions_statistics: '/api/v1/coaches/sessions_statistics',
      tasks: '/api/v1/coaches/tasks',
      billing: '/api/v1/coaches/billing',
      filters: '/api/v2/coaches/filters',
      invoices: {
        index: '/api/v2/coaches/invoices',
        show: (id) => `/leggup_invoices/${id}`,
        update: (id) => `/api/v2/coaches/invoices/${id}`,
        cancel: (id) => `/api/v2/coaches/invoices/${id}/cancel`,
      },
      show: (id) => `/api/v2/coaches/${id}`,
      ratings: {
        index: (coachId) => `/api/v2/coaches/${coachId}/ratings`,
      },
      time_slots: {
        index: (coachId) => `/api/v2/coaches/${coachId}/time-slots`,
      },
    },
    cycles: {
      list: (teamId) => `/api/v1/cycles?enterprise_team_id=${teamId}`,
      create: '/api/v1/cycles',
      edit: (id) => `/api/v1/cycles/${id}/edit`,
      update: (id) => `/api/v1/cycles/${id}`,
      destroy: (id) => `/api/v1/cycles/${id}`,
      members: (id, teamId) => `/api/v1/cycles/${id}/members?enterprise_team_id=${teamId}`,
    },
    users: {
      show: '/api/v2/user',
      notifications: '/api/v2/users/notifications',
      notificationRead: '/api/v2/users/notifications/read',
      schedule_new_sessions: '/api/v1/users/schedule_new_sessions',
      schedule_past_sessions: '/api/v1/users/schedule_past_sessions',
      registration: '/api/v2/users/register',
      impersonate: (id) => `/impersonate/user/${id}`,
      calendars: {
        index: '/api/v2/users/calendars',
        update: '/api/v2/users/calendars/update_calendars',
      },
      chats: {
        index: '/api/v2/users/chats',
        show: (id) => `/api/v2/users/chats/${id}`,
        destroy: (id) => `/api/v2/users/chats/${id}`,
      },
      avatar: '/api/v2/users/avatar',
      skipAiSessionDescriptionPopup: '/api/v2/users/avatar/skip_ai_session_description',
      saveAiSessionFeedback: '/api/v2/users/chat_messages/feedback',
      enterprises: {
        index: '/api/v2/users/enterprises',
        switch: (id) => `/api/v2/users/enterprises/${id}/switch`,
      },
      tokens: {
        create: '/api/v2/users/tokens',
      },
    },
    ratings: {
      list: '/api/v1/ratings',
    },
    enterprises: {
      index: '/api/v2/enterprises',
      show: (id) => `/api/v2/enterprises/${id}`,
      list: '/api/v1/enterprises/list',
      report: '/enterprises/report',
      vb_report: '/enterprises/vb_report',
      book_of_business_report: '/enterprises/book_of_business_report',
      invoice_forecast_report: '/enterprises/invoice_forecast_report',
      airtable_sync: '/enterprises/airtable_sync',
      create: '/api/v2/enterprises',
      update: (id) => `/api/v2/enterprises/${id}`,
      unlock: (id) => `/api/v2/enterprises/${id}/unlock`,
      templates: (id) => `/api/v2/enterprises/${id}/templates`,
      blocked: (id) => `/api/v2/enterprises/${id}/blocked`,
      edit: (id) => `/enterprises/${id}/edit`,
      members: (id) => `/api/v2/enterprises/${id}/members`,
      send_invite: (id) => `/api/v2/enterprises/${id}/send_invite`,
      policy: (id) => `/api/v2/enterprises/${id}/policy`,
      payment_methods: (id) => `/api/v2/enterprises/${id}/payment_methods`,
      file_members_import: (id) => `/api/v2/enterprises/${id}/file_members_import`,
      manual_members_import: (id) => `/api/v2/enterprises/${id}/manual_members_import`,
      choose_create_enterprise: '/questionnaire/create_enterprise',
      w9form_link: '/api/v2/enterprises/w9form_link',
      update_generated_invoice_type: (id) => `/api/v2/enterprises/${id}/update_generated_invoice_type`,
      saveAvatar: (id) => `/api/v2/enterprises/${id}/save_avatar`,
    },
    team_leads: {
      list: '/api/v1/team_leads',
      edit: (id) => `/team_leads/${id}/edit`,
      destroy: (id) => `/api/v1/team_leads/${id}`,
      invite: (id) => `/api/v2/managers/${id}/invite`,
    },
    managers: {
      index: '/api/v2/managers',
      dashboard: {
        statistics: '/api/v2/managers/dashboard/statistics',
        policy_plans: '/api/v2/managers/dashboard/policy_plans',
        programs_paid: '/api/v2/managers/dashboard/programs_paid',
        programs_assigned: '/api/v2/managers/dashboard/programs_assigned',
        members_invited: '/api/v2/managers/dashboard/members_invited',
        programs_started: '/api/v2/managers/dashboard/programs_started',
        assessments_completed: '/api/v2/managers/dashboard/assessments_completed',
        sessions_completed: '/api/v2/managers/dashboard/sessions_completed',
        cpa_top_strengths: '/api/v2/managers/cpa_reports/top_strengths',
        cpa_team_profile: '/api/v2/managers/cpa_reports/team_profile',
        cpa_statistics: '/api/v2/managers/cpa_reports/statistics',
        topics: '/api/v2/managers/topics',
        coach_rating: '/api/v2/managers/ratings/rating?resource_type=Coach',
        session_rating: '/api/v2/managers/session_feedbacks',
        program_rating: '/api/v2/managers/ratings/rating?resource_type=CoachingPlan',
        sessions_statistics: '/api/v2/managers/sessions/statistics',
        member_feedback: '/api/v2/managers/ratings/member_feedback',
      },
      programs: {
        show: (id) => `/api/v2/managers/programs/${id}`,
        assign: (id) => `/api/v2/managers/programs/${id}/assign`,
        download: (id) => `/api/v2/managers/programs/${id}/download`,
        new: '/api/v2/managers/programs/new',
        create: '/api/v2/managers/programs/',
        update: (id) => `/api/v2/managers/programs/${id}`,
        destroy: (id) => `/api/v2/managers/programs/${id}`,
        clone: (id) => `/api/v2/managers/programs/${id}/clone`,
      },
      profile: {
        update: (id) => `/api/v2/managers/${id}`,
      },
      finch: {
        create: '/api/v2/managers/finch',
        update: '/api/v2/managers/finch',
        status: '/api/v2/managers/finch/status',
        preview: '/api/v2/managers/finch/preview',
        import: '/api/v2/managers/finch/import',
      },
      payment_methods: {
        index: '/api/v2/managers/payment_methods',
        new: '/api/v2/managers/payment_methods/new',
        create: '/api/v2/managers/payment_methods',
        update: (id) => `/api/v2/managers/payment_methods/${id}`,
        link: '/api/v2/managers/payment_methods/link',
        delete: (id) => `/api/v2/managers/payment_methods/${id}`,
        assign: '/api/v2/managers/payment_methods/assign/',
        detach: (id) => `/api/v2/managers/payment_methods/${id}/detach`,
      },
      members: {
        lastAssessment: (id) => `/api/v2/managers/members/${id}/last_assessment`,
      },
      coaches: {
        index: '/api/v2/managers/coaches',
        manualImport: '/api/v2/managers/coaches/manual_import',
        invite: '/api/v2/managers/coaches/invite',
        update: (id) => `/api/v2/managers/coaches/${id}`,
        activate: (id) => `/api/v2/managers/coaches/${id}/activate`,
        block: (id) => `/api/v2/managers/coaches/${id}/block`,
      },
      assessments: {
        index: '/api/v2/managers/assessments',
        create: '/api/v2/managers/assessments',
        delete: (id) => `/api/v2/managers/assessments/${id}`,
      },
    },
    file_imports: {
      list: '/api/v1/file_imports',
      show: (id) => `/file_imports/${id}`,
      update: (id) => `/api/v1/file_imports/${id}`,
    },
    file_import_items: {
      index: (fileImportId) => `/file_imports/${fileImportId}/file_import_items`,
      list: '/api/v1/file_import_items',
    },
    member_benefit_payments: {
      list: '/api/v1/member_benefit_payments',
      report: (memberId, cycleId) => `/api/v1/member_benefit_payments/report?member_id=${memberId}&cycle_id=${cycleId}`,
    },
    voluntary_benefit_invoices: {
      list: '/api/v1/voluntary_benefit_invoices',
    },
    credits: {
      list: '/api/v1/credits',
    },
    member_cycle_invoices: {
      list: '/api/v1/member_cycle_invoices',
    },
    teams: {
      list: '/api/v1/teams',
      index: '/api/v2/teams',
      edit: (enterpriseId, teamId) => `/enterprises/${enterpriseId}/enterprise_teams/${teamId}/edit`,
      create: '/api/v2/teams',
      update: (id) => `/api/v2/teams/${id}`,
      destroy: (id) => `/api/v2/teams/${id}`,
      assign_coach_pool: (id) => `/api/v2/teams/${id}/assign_coach_pool`,
      remove_coach_pool: (id) => `/api/v2/teams/${id}/remove_coach_pool`,
      topics: (id) => `/api/v2/teams/${id}/topics`,
      assign_topic: (id) => `/api/v2/teams/${id}/assign_topic`,
      remove_topic: (id) => `/api/v2/teams/${id}/remove_topic`,
      cycles: {
        index: (teamId) => `/api/v2/teams/${teamId}/cycles`,
      },
    },
    templates: {
      list: '/api/v1/templates',
      index: '/api/v2/templates',
      show: (id) => `/api/v2/templates/${id}`,
      close_all: (id) => `/api/v2/templates/${id}/close-all`,
    },
    programs: {
      possibleStartNewProgram: '/api/v2/programs/possible_start_new_program',
      show: (id) => `/api/v2/programs/${id}`,
      close: (id) => `/api/v2/programs/${id}/close`,
      unassign: (id) => `/api/v2/programs/${id}/unassign`,
      saveForLater: (id) => `/api/v2/programs/${id}/saved_for_later`,
      start: (id) => `/api/v2/programs/${id}/started`,
      coachFeedback: (id) => `/api/v2/programs/${id}/coach-feedback`,
      programFeedback: (id) => `/api/v2/programs/${id}/program-end-survey`,
      prepareShare: (id) => `/api/v2/programs/${id}/prepare_share`,
      share: (id) => `/api/v2/programs/${id}/share`,
    },
    checkouts: {
      list: '/api/v1/checkouts',
      add: '/api/v1/checkouts/add',
      remove: '/api/v1/checkouts/remove',
      removeAll: '/api/v1/checkouts/remove_all',
      create_invoice: '/api/v1/checkouts/create_invoice',
    },
    required_actions: {
      complete: (id) => `/api/v1/required_actions/${id}/complete`,
      list: '/api/v2/required_actions',
      skip: '/api/v2/required_actions/skip',
    },
    topic_categories: {
      index: '/api/v2/topic_categories',
      create: '/api/v2/topic_categories',
      destroy: (id) => `/api/v2/topic_categories/${id}`,
      update: (id) => `/api/v2/topic_categories/${id}`,
      sort: '/api/v2/topic_categories/sort',
    },
    topics: {
      index: '/api/v2/topics',
      show: (id) => `/api/v2/topics/${id}`,
      create: '/api/v2/topics',
      destroy: (id) => `/api/v2/topics/${id}`,
      edit: (id) => `/topics/${id}/edit`,
    },
    policy_plan_templates: {
      index: '/api/v2/policy_plan_templates',
      create: '/api/v2/policy_plan_templates',
      update: (id) => `/api/v2/policy_plan_templates/${id}`,
      sort: '/api/v2/policy_plan_templates/sort',
      destroy: (id) => `/api/v2/policy_plan_templates/${id}`,
    },
    policy_plan_custom_record_templates: {
      index: '/api/v2/policy_plan_custom_record_templates',
      create: '/api/v2/policy_plan_custom_record_templates',
      update: (id) => `/api/v2/policy_plan_custom_record_templates/${id}`,
      destroy: (id) => `/api/v2/policy_plan_custom_record_templates/${id}`,
    },
    policies: {
      create: '/api/v2/policies',
      update: (id) => `/api/v2/policies/${id}`,
      unlock: (id) => `/api/v2/policies/${id}/unlock`,
    },
    policy_plans: {
      index: '/api/v2/policy_plans',
      possible_start: '/api/v2/policy_plans/possible_start',
      new: '/api/v2/policy_plans/new',
      create: '/api/v2/policy_plans',
      update: (id) => `/api/v2/policy_plans/${id}`,
      destroy: (id) => `/api/v2/policy_plans/${id}`,
      activate: (id) => `/api/v2/policy_plans/${id}/activate`,
      renewal: (id) => `/api/v2/policy_plans/${id}/renewal`,
      show: (id) => `/api/v2/policy_plans/${id}`,
      downloadPdf: '/api/v2/policy_plans/policy_pdf',
    },
    policy_documents: {
      create: '/api/v2/policy_documents',
      destroy: (id) => `/api/v2/policy_documents/${id}`,
    },
    policy_invoices: {
      index: '/api/v2/policy_invoices',
      pay: (id) => `/api/v2/policy_invoices/${id}/pay`,
    },
    policy_templates: {
      index: '/api/v2/policy_templates',
      update: (id) => `/api/v2/policy_templates/${id}`,
      sort: '/api/v2/policy_templates/sort',
    },
    countries: {
      index: '/api/v2/countries',
      phone_countries: '/api/v2/countries/phone_countries',
      states: (code) => `/api/v2/countries/${code}/states`,
    },
    time_zones: {
      index: '/api/v2/time_zones',
    },
    team_sizes: {
      index: '/api/v2/team_sizes',
    },
    business_sizes: {
      index: '/api/v2/business_sizes',
    },
    industries: {
      index: '/api/v2/industries',
    },
    career_levels: {
      index: '/api/v2/career_levels',
    },
    year_experiences: {
      index: '/api/v2/year_experiences',
    },
    languages: {
      index: '/api/v2/languages',
    },
    resource_categories: {
      index: '/api/v2/resource_categories',
      create: '/api/v2/resource_categories',
      update: (id) => `/api/v2/resource_categories/${id}`,
      destroy: (id) => `/api/v2/resource_categories/${id}`,
    },
    resource_notes: {
      index: '/api/v2/resource_notes',
      create: '/api/v2/resource_notes',
      update: (id) => `/api/v2/resource_notes/${id}`,
      destroy: (id) => `/api/v2/resource_notes/${id}`,
    },
    resources: {
      index: '/api/v2/resources',
      create: '/api/v2/resources',
      update: (id) => `/api/v2/resources/${id}`,
      destroy: (id) => `/api/v2/resources/${id}`,
    },
    currencies: {
      index: '/api/v2/currencies',
    },
    affiliates: {
      index: '/api/v2/affiliates',
      update: (id) => `/api/v2/affiliates/${id}`,
      requestTraining: (id) => `/api/v2/affiliates/${id}/request-training`,
      approveTraining: (id) => `/api/v2/affiliates/${id}/approve-training`,
      destroy: (id) => `/api/v2/affiliates/${id}`,
      plans: (id) => `/api/v2/affiliates/${id}/plans`,
      invite: (id) => `/api/v2/affiliates/${id}/invite`,
      prospects: {
        index: '/api/v2/affiliates/prospects',
        create: '/api/v2/affiliates/prospects',
        show: (id) => `/api/v2/affiliates/prospects/${id}`,
        update: (id) => `/api/v2/affiliates/prospects/${id}`,
        destroy: (id) => `/api/v2/affiliates/prospects/${id}`,
      },
      payments: {
        index: '/api/v2/affiliates/payments',
        pay: (id) => `/api/v2/affiliates/payments/${id}/pay`,
      },
      statistics: {
        index: '/api/v2/affiliates/statistics',
      },
    },
    affiliateTrainings: {
      markCompleted: '/api/v2/affiliates/trainings/complete',
    },
    affiliateTrainingStepDocuments: {
      markAsRead: (id) => `/api/v2/affiliates/training_step_documents/${id}/read`,
    },
    affiliateTrainingSteps: {
      index: '/api/v2/affiliate_training_steps',
      sort: '/api/v2/affiliate_training_steps/sort',
      create: '/api/v2/affiliate_training_steps',
      update: (id) => `/api/v2/affiliate_training_steps/${id}`,
      destroy: (id) => `/api/v2/affiliate_training_steps/${id}`,
    },
    super_admins: {
      users: {
        destroy: (id) => `/api/v2/super_admins/users/${id}`,
        restore: (id) => `/api/v2/super_admins/users/${id}/restore`,
      },
      coaches: {
        index: '/api/v2/super_admins/coaches',
        enable_delete_data: (id) => `/api/v2/super_admins/coaches/${id}/enable_delete_data`,
        fill_profile_data: (id) => `/api/v2/super_admins/coaches/${id}/fill_profile_data`,
      },
      session_rooms: {
        index: '/api/v2/super_admins/session_rooms',
      },
      personalFiles: {
        index: '/api/v2/super_admins/personal_files',
      },
      avatars: {
        index: '/api/v2/super_admins/avatars',
        show: (id) => `/api/v2/super_admins/avatars/${id}`,
        create: '/api/v2/super_admins/avatars',
        update: (id) => `/api/v2/super_admins/avatars/${id}`,
        destroy: (id) => `/api/v2/super_admins/avatars/${id}`,
      },
      prompts: {
        index: '/api/v2/super_admins/prompts',
        show: (id) => `/api/v2/super_admins/prompts/${id}`,
        create: '/api/v2/super_admins/prompts',
        update: (id) => `/api/v2/super_admins/prompts/${id}`,
        destroy: (id) => `/api/v2/super_admins/prompts/${id}`,
      },
      aiSessions: {
        index: '/api/v2/super_admins/ai_sessions',
        show: (id) => `/api/v2/super_admins/ai_sessions/${id}`,
      },
    },
    webinars: {
      index: '/api/v2/webinars',
      create: '/api/v2/webinars',
      start: (id) => `/api/v2/webinars/${id}/start`,
      update: (id) => `/api/v2/webinars/${id}`,
      destroy: (id) => `/api/v2/webinars/${id}`,
    },
    report_templates: {
      index: '/api/v2/super_admins/report_templates',
      create: '/api/v2/super_admins/report_templates',
      show: (id) => `/api/v2/super_admins/report_templates/${id}`,
      update: (id) => `/api/v2/super_admins/report_templates/${id}`,
      destroy: (id) => `/api/v2/super_admins/report_templates/${id}`,
      generate: (id) => `/api/v2/report_templates/${id}/generate`,
      status: '/api/v2/report_templates/status',
    },
    report_contents: {
      index: '/api/v2/report_contents',
      destroy: (id) => `/api/v2/report_contents/${id}`,
    },
    enterprise_briefs: {
      index: '/api/v2/super_admins/enterprise_briefs',
      create: '/api/v2/super_admins/enterprise_briefs',
      show: (id) => `/api/v2/super_admins/enterprise_briefs/${id}`,
      update: (id) => `/api/v2/super_admins/enterprise_briefs/${id}`,
      destroy: (id) => `/api/v2/super_admins/enterprise_briefs/${id}`,

    },
    career_pulse_assessment_reports: {
      index: '/api/v2/career_pulse_assessment_reports',
      latest: '/api/v2/career_pulse_assessment_reports/latest',
      create: '/api/v2/career_pulse_assessment_reports',
      possibleSkip: '/api/v2/career_pulse_assessment_reports/possible_skip',
      skip: '/api/v2/career_pulse_assessment_reports/skip',
    },
    career_pulse_questions: {
      index: '/api/v2/career_pulse_questions',
    },
    learner_style_questions: {
      index: '/api/v2/learner_style_questions',
    },
    slack: {
      channels: 'https://6jbebkb51g.execute-api.us-east-2.amazonaws.com/v1/api/v1/slack/channels',
      updateChannel: 'https://6jbebkb51g.execute-api.us-east-2.amazonaws.com/v1/api/v1/slack/channels',
      unlink: 'https://6jbebkb51g.execute-api.us-east-2.amazonaws.com/v1/api/v1/slack/channels',
      setupPrepare: '/api/v2/super_admins/slack_setup',
      sendSetupMail: '/api/v2/super_admins/slack_setup/send_setup_mail',
    },
    heygen: {
      token: '/api/v2/heygens/token',
    },
  },

  admin: {
    affiliates: {
      edit: (id) => `/admin/affiliates/${id}/edit`,
    },
    policy_billings: {
      report: '/admin/policy_billings/report',
    },
    resource_categories: {
      index: '/admin/resource_categories',
      new: '/admin/resource_categories/new',
      edit: (id = ':categoryId') => `/admin/resource_categories/${id}/edit`,
    },
    resources: {
      index: '/admin/resources',
      new: '/admin/resources/new',
      edit: (id = ':resourceId') => `/admin/resources/${id}/edit`,
    },
    report_templates: {
      index: '/admin/report_templates',
      new: '/admin/report_templates/new',
      edit: (id = ':reportTemplateId') => `/admin/report_templates/${id}/edit`,
      run: (id = ':reportTemplateId') => `/admin/report_templates/${id}/run`,
    },
    enterprise_briefs: {
      index: (enterpriseId) => `/enterprises/${enterpriseId}/edit`,
      new: (enterpriseId) => `/enterprises/${enterpriseId}/edit/briefs/new`,
      edit: (enterpriseId, id = ':enterpriseBriefId') => `/enterprises/${enterpriseId}/edit/briefs/edit/${id}`,
    },
    coaches: {
      edit: (id) => `/coaches/${id}/edit`,
    },
  },

  members: {
    onboarding: {
      index: '/members/onboarding',
      welcome: '/members/onboarding/welcome',
      welcomeCpa: '/members/onboarding/welcome-assessment',
      continue: '/members/onboarding/continue',
      continueCpa: '/members/onboarding/continue-assessment',
      start_talent_assessment: '/members/onboarding/start-talent-assessment',
      talent_assessment: '/members/onboarding/talent-assessment',
      prepare_assessment_report: '/members/onboarding/prepare-talent-assessment-report',
      talent_assessment_report: '/members/onboarding/talent-assessment-report',
      cpa_program_report: '/members/onboarding/talent-assessment-report',
      talentAssessmentDownload: '/members/onboarding/talent-assessment-download',
      prepareBuildProgram: '/members/onboarding/prepare-build-program',
      orderTopic: (programId = ':programId') => `/members/onboarding/order-topic/${programId}`,
      coachMatch: '/members/onboarding/coach-match',
      learningStyle: '/members/onboarding/learning-style',
      preferences: '/members/onboarding/preferences',
      findingCoach: '/members/onboarding/finding-coach',
      chooseCoach: (programId = ':programId') => `/members/onboarding/choose-coach/${programId}`,
      finalize: '/members/onboarding/finalize',
      summary: (programId = ':programId') => `/members/onboarding/summary/${programId}`,
      finish: '/members/onboarding/finish',
      webview: '/members/onboarding/webview',
      welcomeRTW: '/members/onboarding/welcome-return-to-work',
    },
    activateProgram: {
      index: '/members/activate_program',
      emailUpdate: '/members/activate_program/email_update',
    },
    programs: {
      index: '/members/programs',
      chooseType: '/members/programs/new/choose-type',
      new: {
        index: '/members/programs/new',
        orderTopics: (programId = ':programId') => `/members/programs/new/${programId}/order-topics`,
        talentAssessment: (programId = ':programId') => `/members/programs/new/${programId}/assessment`,
        talentAssessmentShow: (programId = ':programId') => `/members/programs/new/${programId}/assessment-show`,
        learningStyle: (programId = ':programId') => `/members/programs/new/${programId}/learning-style`,
        myPreferences: (programId = ':programId') => `/members/programs/new/${programId}/my-preferences`,
        selectCoach: (programId = ':programId') => `/members/programs/new/${programId}/select-coach`,
        confirm: (programId = ':programId') => `/members/programs/new/${programId}/confirm`,
        setTopic: (stepId = ':stepId') => `step/${stepId}/change-topic`,
        webview: '/members/programs/new/webview',
      },
      new_ai: {
        index: '/members/programs/new-ai',
        goals: '/members/programs/new-ai/goals',
        prepareProgram: '/members/programs/new-ai/prepare-program',
        orderTopics: (programId = ':programId') => `/members/programs/new-ai/${programId}/order-topics`,
        confirm: (programId = ':programId') => `/members/programs/new-ai/${programId}/confirm`,
        setTopic: (stepId = ':stepId') => `step/${stepId}/change-topic`,
        webview: '/members/programs/new-ai/webview',
      },
      show: (id = ':programId') => `/members/programs/${id}`,
      download: (id) => `/members/programs/${id}/download`,
      coachFeedback: (id = ':programId') => `/members/programs/${id}/coach-feedback`,
      programFeedback: (id = ':programId') => `/members/programs/${id}/program-end-survey`,
      chooseNewCoach: (id = ':programId') => `/members/programs/${id}/choose-coach`,
      talentAssessments:
        (id = ':programId', type = ':typeAssessment') => `/members/programs/${id}/talent-assessments/${type}`,
      talentAssessmentsShow:
        (id = ':programId', type = ':typeAssessment') => `/members/programs/${id}/talent-assessments/${type}/show`,
      growthReportShow:
        (id = ':programId') => `/members/programs/${id}/growth-report`,
      program: {
        share: 'share',
        changeCoach: 'change-coach',
        step: {
          changeTopic: (stepId = ':stepId') => `step/${stepId}/change-topic`,
          buyOrSkip: (stepId = ':stepId') => `step/${stepId}/buy-or-skip`,
        },
      },
    },
    chats: {
      index: '/members/chat',
      messages: (id = ':chatId') => `/members/chat/${id}`,
    },
    schedule: {
      index: '/members/schedule',
    },
    steps: {
      schedule: (stepId = ':stepId') => `/members/steps/${stepId}/schedule`,
      buyOrSkipSchedule: (stepId = ':stepId') => `/members/steps/${stepId}/schedule/buy-or-skip`,
      timezone: (stepId = ':stepId') => `/members/steps/${stepId}/schedule/timezone`,
      scheduleSummary: (stepId = ':stepId') => `/members/steps/${stepId}/schedule/summary`,
      buyOrSkip: (stepId = ':stepId') => `/members/schedule/steps/${stepId}/buy-or-skip`,
      zoomInfo: (stepId = ':stepId') => `/members/schedule/steps/${stepId}/zoom-info`,
      content:
        (
          programId = ':programId',
          stepId = ':stepId',
          resourceId = ':resourceId',
        ) => `/members/programs/${programId}/steps/${stepId}/content/${resourceId}`,
    },
    assessments: {
      index: '/members/assessments',
    },
    talentAssessment: {
      show: '/members/talent-assessment',
      new: '/members/talent-assessment/new',
    },
    growthReport: {
      show: '/members/growth-report',
    },
    learningStyle: {
      show: '/members/learning-style',
      new: '/members/learning-style/new',
    },
    profile: {
      index: '/members/profile',
      general: '/members/profile/edit/general',
      basic: '/members/profile/edit/basic',
      password: '/members/profile/edit/password',
      languages: '/members/profile/edit/languages',
      experience: '/members/profile/edit/experience',
      career_history: '/members/profile/edit/career_history',
    },
    settings: {
      index: '/members/settings',
      emailUpdate: '/members/settings/email',
      passwordUpdate: '/members/settings/password',
    },
    webview: {
      finish: '/members/webview/finish',
    },
  },

  managers: {
    dashboard: {
      index: '/managers/dashboard',
      report: (params = '') => `/managers/dashboard/report?${params}`,
    },
    billing: {
      index: '/managers/billing',
      noPolicy: '/managers/billing/no-policy',
    },
    members: {
      index: '/managers/members',
      assessments: (id = ':memberId') => `/managers/members/${id}/assessments`,
      add: '/managers/members/add',
      manual: '/managers/members/add/manual',
      hrSystem: {
        index: '/managers/members/add/hr-system',
        import: '/managers/members/add/hr-system/import',
      },
      file: '/managers/members/add/file',
      success: '/managers/members/add/success',
      invite: '/managers/members/invite',
    },
    programs: {
      index: '/managers/programs',
      noPolicy: '/managers/programs/no-policy',
      assign: (id) => `/managers/programs/${id}/assign`,
      success: '/managers/programs/success',
    },
    invite: {
      index: '/managers/members/invite',
    },
    teams: {
      index: '/managers/teams',
    },
    templates: {
      index: '/managers/templates',
      new: '/managers/templates/new',
      chooseTopics: '/managers/templates/new/choose-topics',
      orderTopics: '/managers/templates/new/order-topics',
      summary: '/managers/templates/new/summary',
      editChooseTopics: (id = ':templateId') => `/managers/templates/${id}/choose-topics`,
      editOrderTopics: (id = ':templateId') => `/managers/templates/${id}/order-topics`,
      editSummary: (id = ':templateId') => `/managers/templates/${id}/summary`,
    },
    policy: {
      index: '/managers/policy',
    },
    plans: {
      index: '/managers/plans',
      new: {
        company: '/managers/policy/plans/new/company',
        choose_template: '/managers/policy/plans/new/choose-template',
        plan_details: '/managers/policy/plans/new/plan-details',
        services: '/managers/policy/plans/new/services',
        summary: '/managers/policy/plans/new/summary',
        success: '/managers/policy/plans/new/success',
      },
      edit: {
        plan_details: (id = ':planId') => `/managers/policy/plans/edit/${id}/plan-details`,
        services: (id = ':planId') => `/managers/policy/plans/edit/${id}/services`,
        summary: (id = ':planId') => `/managers/policy/plans/edit/${id}/summary`,
        success: (id = ':planId') => `/managers/policy/plans/edit/${id}/success`,
      },
      show: (id = ':planId') => `/managers/policy/plans/${id}`,
      activated: (id = ':planId') => `/managers/policy/plans/${id}/activated`,
    },
    coaches: {
      index: '/managers/coaches',
      add: '/managers/coaches/add',
      successImport: '/managers/coaches/add/success',
    },
  },

  affiliates: {
    prospects: {
      index: '/affiliates/prospects',
      new: '/affiliates/prospects/new',
      edit: (id = ':prospectId') => `/affiliates/prospects/${id}/edit`,
      calculator: '/affiliates/prospects/calculator',
    },
    training: {
      certificate: '/affiliates/training/certificate',
    },
  },

  coaches: {
    show: (id = ':coachId') => `/coaches/${id}`,
  },
};

export default routes;
